export default __webpack_public_path__ + "static/media/icons8-linkedin.076f7337.svg";